'use strict';

var _ = require('lodash');

var DialogViewFactory = function () {
  
  var DEFAULTS = {
    _current: '', // currently visible view id
    _default: '', // default view id
    id: '',
    views: null, // id to controller map
    viewStack: null,
  };

  var instances = {};

  /**
   * constructor
   * 
   * @param {String|Number} id the id of the dialog controller the views belong to
   */
  function DialogViewFactory (id) {
    if (instances[id] instanceof DialogViewFactory) {
      return instances[id];
    }

    // initialize and save the instance
    _.extend(this, DEFAULTS);
    
    this.id = id;
    this.views = {};
    this.viewStack = [];
    
    instances[id] = this;
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Getters
  ///////////////////////////////////////////////////////////////////////////////////////////


  DialogViewFactory.create = function (id) {
    return new DialogViewFactory(id);
  };

  /**
   * Get the id of the current view
   * 
   * @return {String|Number} view id
   */
  DialogViewFactory.prototype.getCurrentView = function () {
    return this._current;
  };

  /**
   * Get the id of the default view
   * 
   * @return {String|Number} view id
   */
  DialogViewFactory.prototype.getDefaultView = function () {
    return this._default;
  };

  /**
   * Get the id of the previous view
   * 
   * @return {String|Number} view id
   */
  DialogViewFactory.prototype.getPreviousView = function () {
    var id = this.viewStack.pop();
    return id;
  };

  /**
   * Get the view controller
   * 
   * @param  {String|Number} id view id
   * @return {Object} view controller instance
   */
  DialogViewFactory.prototype.getViewCtrl = function (id) {
    return this.views[id];
  };

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Setters
  ///////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Used to keep track of the dialog's individual views
   *
   * @param  {String|Number} id the view id
   * @param  {Object} ctrl the view controller
   */
  DialogViewFactory.prototype.register = function (id, ctrl) {
    this.views[id] = ctrl;

    // if this is the first registered view, set it to be the default
    if (!this.getDefaultView()) {
      this.setDefaultView(id);
    }
  };

  /**
   * Destroy the view factory.
   */
  DialogViewFactory.prototype.destroy = function () {
    this.views = {};
    this.viewStack = [];
    delete instances[this.id];
  };

  DialogViewFactory.prototype.removeView = function (id) {
    if (this._current === id) {
      this._current = '';
    }

    this.viewStack = []; // reset the view stack... don't think it makes sense to splice
    delete this.views[id];
  };

  /**
   * Resets the view stack
   */
  DialogViewFactory.prototype.resetViewStack = function () {
    this.viewStack = [];
  };

  /**
   * Set the default view to the given view id
   * 
   * @param  {String|Number} id the view id
   */
  DialogViewFactory.prototype.setDefaultView = function (id) {
    this._default = id;
  };

  /**
   * Show the given view and hides the currently active view.
   * Also saves the previous view id to the view stack.
   * 
   * @param  {String|Number} [id] view id
   * @return {String|Number} view id
   */
  DialogViewFactory.prototype.switchToView = function (id) {
    if (!id) {
      id = this.getDefaultView();
    }

    if (this._current === id) {
      return id;
    }

    var nextViewCtrl = this.getViewCtrl(id);
    var prevViewCtrl = this.getViewCtrl(this._current);

    // make sure the view actually exists
    if (!nextViewCtrl) {
      throw new Error('Dialog view "' + id + '" has not been registered');
    }

    // save previous view
    if (this._current) {
      this.viewStack.push(this._current);
    }

    // set current view id to new id
    this._current = id;

    if (prevViewCtrl) {
      prevViewCtrl.show = false;
    }

    nextViewCtrl.show = true;

    return id;
  };

  return DialogViewFactory;
};

module.exports = DialogViewFactory;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dialog/src/dialogView/DialogViewFactory.js